<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 600px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { getUserRecordStat } from '@/api/user/user_info'

export default {
  name: 'UserRecordStat',
  props: {
    typ: {
      type: Number,
      default: 14
    }
  },
  data() {
    return {
      color: { 14: '#ff0000', 15: '#3CB371', 65: '#FFA500', 22: '#FF4500' },
      queryParams: {
        uid: 0,
        queryParams: ''
      },
      typeArr: {
        14: '金币',
        15: '体力',
        65: '野兽币',
        22: '钻石'
      },
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '变化'
        },
        xAxis: {
          name: '时间',
          type: 'category',
          data: [],
          axisLabel: {
            interval: 0, // 设置为0，表示所有的标签都显示
            rotate: 45 // 将标签旋转90度
          }
        },
        grid: {
          left: '10%',
          right: '10%',
          bottom: '20%',
          top: '50%' // 让折线图留出上方空间
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [{
          name: '新增',
          data: [],
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          },
          itemStyle: {
            normal: {
              color: this.color[this.typ] // 改变线条颜色
            }
          }
        }, {
          name: '占比',
          type: 'pie',
          radius: '35%',
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          center: ['50%', '25%'],
          data: [],
          label: {
            formatter: '{b}: {c} ({d}%)'
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)' // 显示扇区的名称、数值和占比
          }
        }]
      }
    },
    refresh(queryParams) {
      if (!queryParams.uid) {
        return
      }
      this.queryParams.startDate = queryParams.startDate
      this.queryParams.endDate = queryParams.endDate
      this.queryParams.uid = queryParams.uid
      this.queryParams.level = this.typ
      getUserRecordStat(this.queryParams).then(res => {
        const { data, changeLog, type: ridType } = res.data
        const time = []
        const value = []
        for (const i in data) {
          const val = data[i]
          time.push(val.time)
          if (this.typ === 65) {
            val.num = (val.num / 10000).toFixed(2)
          }
          value.push(val.num)
        }

        const circleData = []
        if (changeLog.length) {
          for (const i in changeLog) {
            const val = changeLog[i]
            let num = val.num2
            if (this.typ === 65) {
              num = (val.num2 / 10000).toFixed(2)
            }
            circleData.push({ value: num, name: ridType[val.rid] })
          }
        }

        this.option.title.text = this.typeArr[this.typ] + '变化'
        this.option.xAxis.data = time
        this.option.series[0].name = this.typeArr[this.typ]
        this.option.series[0].data = value
        this.option.series[1].data = circleData
        this.chart.setOption(this.option, true)
      })
    }
  }

}
</script>

<style scoped>

</style>
